import {
  GetIvsClientIdFunction,
  GetLoginIvsEventTypeFunction,
  GetOneCredentialLoginIvsEventTypeFunction,
} from '@shopee-user/business-customization-types';

const IVS_CLIENT_ID = 11;

export const getIvsClientId: GetIvsClientIdFunction = () => {
  return IVS_CLIENT_ID;
};

export const getLoginIvsEventType: GetLoginIvsEventTypeFunction = () => {
  return -1;
};

export const getOneCredentialLoginIvsEventType: GetOneCredentialLoginIvsEventTypeFunction = () => {
  return -1;
};
